import APIRequestState from './_util/api-request';

class CancellationPolicyState extends APIRequestState {
  get method() { return 'GET'; }
  get url() { return '/orders/policy/cancellation'; }
}

export default CancellationPolicyState;



// WEBPACK FOOTER //
// ./spa/state/cancellation-policy.jsx